import styles from './ProfileImage.module.scss'
import classNames from 'classnames'
import { useEffect, useState } from 'react'
import { useGetIsAuthUser } from '@/shared/hooks/useGetIsAuthUser'
import { TOAST_ERROR } from '@/shared/constants/toastTypes'
import api from '@/shared/api'
import { useCheckUserMutation } from '@/shared/api-rtk'
import { IMAGE_DIR } from '@/shared/constants/linksApi'

export const ProfileImage = ({ image, userData, onImageUpload }) => {
    const { userAuth, userInfo } = useGetIsAuthUser()
    const [previewAvatar, setPreviewAvatar] = useState()

    // image={userData.avatar ? ((userData.password=="VK" || userData.password=="TG") ? userData.avatar : "/cms/image/"+userData.avatar) : '/bg/upload-image-profile.png'} />

    const checkImage = () => {

        if (image.avatar && typeof image.avatar === 'string' && image.avatar.trim() !== '')
            return IMAGE_DIR + 'avatars/' + userData.avatar + `?t=${Date.now()}`

        if (image.password === 'VK' || image.password === 'TG')
            return image.avatar

        if (previewAvatar)
            return previewAvatar

        return '/bg/upload-image-profile.png'
    }

    const inputFileHandler = async (e) => {
        if (!userAuth) {
            TOAST_ERROR('Не удалось загрузить аватар')
        }
        setPreviewAvatar(URL.createObjectURL(e.target.files[0]))
        // const data = new FormData()
        // data.append('file', e.target.files[0])
        // data.append('customer_id', userData.customer_id)

        // //resp
        // const response = await api.post(
        //     'index.php?route=/api/customer/uploadImage',
        //     data
        // )
        
        onImageUpload(e.target.files[0])
    }

    return (
        <div className={classNames('ProfileImage', styles.wrapper)}>
            <div className={classNames(styles.imageWrapper)}>
                <img
                    className={classNames(styles.image)}
                    src={`${checkImage()}`}
                    alt="upload-image"
                />
            </div>
            <div className={classNames(styles.inputWrapper)}>
                <label className={classNames(styles.label)}>
                    {' '}
                    Загрузить фотографию
                    <input
                        className={classNames(styles.input)}
                        type="file"
                        onChange={inputFileHandler}
                    />
                </label>
            </div>
        </div>
    )
}
